import React from "react";
import { CheckIcon } from "lucide-react";
import { InquiryForm, type FormField } from "../components/InquiryForm";
import { wholesaleTiers, retailerReasons, businessTypes } from "../data/wholesaleData";
const fields: FormField[] = [{
  name: "business",
  label: "Business name",
  required: true,
  half: true
}, {
  name: "type",
  label: "Business type",
  type: "select",
  options: businessTypes,
  required: true,
  half: true
}, {
  name: "name",
  label: "Contact name",
  required: true,
  half: true
}, {
  name: "email",
  label: "Email",
  type: "email",
  required: true,
  half: true
}, {
  name: "phone",
  label: "Phone",
  type: "tel",
  half: true
}, {
  name: "locations",
  label: "Number of locations",
  half: true
}, {
  name: "tax",
  label: "Resale / tax ID",
  half: true
}, {
  name: "tier",
  label: "Interested in",
  type: "select",
  options: wholesaleTiers.map(t => t.name),
  half: true
}, {
  name: "note",
  label: "Anything else?",
  type: "textarea"
}];
export function Wholesale() {
  return <div className="mx-auto max-w-6xl px-5 py-12 md:py-16" data-id="element-287" data-mp="24jl2y8b5kt25">
      <header className="max-w-2xl" data-id="element-288" data-mp="24l5vjsdwq1xd">
        <h1 className="font-display text-5xl font-bold uppercase leading-none tracking-tight text-ink md:text-6xl" data-id="element-289" data-mp="28kn1so15r33l">Wholesale for shops &amp; distributors</h1>
        <p className="mt-4 text-lg text-muted" data-id="element-290" data-mp="2diomtei59chp">Sklunx Krushers: collectible character pill crushers. Suggested retail price is $14.99. Every order ships with display-ready packaging.</p>
      </header>

      <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-291" data-mp="2n9jamnb1gk59">
        {wholesaleTiers.map(t => <li key={t.id} className={`flex flex-col rounded-2xl p-6 ${t.featured ? "bg-ink text-paper" : "border border-line bg-white text-ink"}`} data-id="element-292" data-mp="2s72m5fgcqiti">
            <h2 className="text-lg font-semibold" data-id="element-293" data-mp="31a3rhdxe85w4">{t.name}</h2>
            <p className={`text-sm ${t.featured ? "text-paper/70" : "text-muted"}`} data-id="element-294" data-mp="317hj5c2ohmcu">{t.who}</p>
            <p className="mt-6 font-display text-3xl tracking-wide" data-id="element-295" data-mp="11ykix0g04zmz">{t.price}</p>
            <p className={`text-sm ${t.featured ? "text-paper/70" : "text-muted"}`} data-id="element-296" data-mp="16w2t0u5r9kwk">per unit · {t.units}</p>
            <ul className="mb-8 mt-6 flex flex-col gap-2 text-sm" data-id="element-297" data-mp="2a6qfva669noq">
              {t.perks.map(p => <li key={p} className="flex gap-2" data-id="element-298" data-mp="259865hkbz4fo">
                  <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${t.featured ? "text-amber" : "text-sage"}`} data-id="element-299" data-mp="2j7eti3rnlm13" />
                  {p}
                </li>)}
            </ul>
            <a href="#apply" className={`mt-auto inline-flex justify-center rounded-full px-5 py-2.5 text-sm font-medium transition-colors duration-150 ${t.featured ? "bg-paper text-ink hover:bg-mist" : "border border-ink hover:bg-mist"}`} data-id="element-300" data-mp="2t4sxv50aykd1">
              Apply for {t.name.toLowerCase()}
            </a>
          </li>)}
      </ul>

      <section aria-labelledby="why-h" className="mt-16 grid gap-10 md:grid-cols-[1fr_2fr]" data-id="element-301" data-mp="2xwkqrm6xl26c">
        <h2 id="why-h" className="text-xl font-semibold text-ink" data-id="element-302" data-mp="3bwlt762ughnx">Why shops carry it</h2>
        <dl className="grid gap-8 sm:grid-cols-3" data-id="element-303" data-mp="36xsb10cm42hf">
          {retailerReasons.map(r => <div key={r.title} data-id="element-304" data-mp="3qjkgcouo4pwu">
              <dt className="font-semibold text-ink" data-id="element-305" data-mp="3qjan8sebu2mx">{r.title}</dt>
              <dd className="mt-1 text-sm text-muted" data-id="element-306" data-mp="3vgkm0ynlvqnf">{r.text}</dd>
            </div>)}
        </dl>
      </section>

      <section id="apply" aria-labelledby="apply-h" className="mt-16 grid scroll-mt-24 gap-10 rounded-3xl bg-white p-6 md:grid-cols-[1fr_1.4fr] md:p-10" data-id="element-307" data-mp="3gjtiqeat9usj">
        <div data-id="element-308" data-mp="37rhwl4mqctid">
          <h2 id="apply-h" className="text-2xl font-semibold text-ink" data-id="element-309" data-mp="37rrpp132ngsa">Open a wholesale account</h2>
          <p className="mt-3 text-muted" data-id="element-310" data-mp="3cjt7f2j0dzpp">We review applications within one business day. Approved accounts get the line sheet and ordering link.</p>
        </div>
        <InquiryForm fields={fields} submitLabel="Submit application" successTitle="Application sent" successText="Watch your inbox for the line sheet and next steps." data-id="element-311" data-mp="32sy8oyokt7nd" />
      </section>
    </div>;
}